import { ImageCaptionDTO, RawImageCaption } from './api.types';

export enum CommunityStatus {
  PRIVATE = 'PRIVATE',
  GLOBAL = 'GLOBAL',
  CLOSED = 'CLOSED',
  DELETED = 'DELETED',
  CLUB_FORUM = 'CLUB FORUM',
}
export enum RequestStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  DECLINED = 'REJECTED',
}

export interface IModerator {
  id: string;
  name: string;
  email?: string;
}

export interface ICommunityTranslation {
  name?: string;
  description?: string;
  tags?: string[];
}

export interface ICommunityData {
  id: string;
  name: string;
  description?: string;
  moderator_ids?: string[];
  moderators?: IModerator[];
  status: CommunityStatus;
  tags?: string[];
  max_users?: number | null;
  language?: string;
  created_at?: string;
  updated_at?: string;
  moderator_id?: string;
  moderator?: IModerator;
  user_role?: string;
  is_yacht_club_community?: boolean;
  translations?: Record<string, ICommunityTranslation> | null;
}

export interface ICommunityById {
  data: ICommunityData;
}

export interface CommunityResponse {
  status: boolean;
  message: string;
  data: {
    id: string;
    name: string;
    description?: string;
    moderator_id?: string;
    status: 'OPEN' | 'PRIVATE' | 'GLOBAL' | 'CLOSED' | 'DELETED';
    tags?: string[];
    max_users?: number;
    language?: string;
    created_at?: string;
    updated_at?: string;
    moderator?: {
      id: string;
      name: string;
      email?: string;
    };
    moderator_ids?: string[];
    moderators?: IModerator[];
    user_role?: string;
    is_yacht_club_community?: boolean;
    translations?: Record<string, ICommunityTranslation> | null;
  };
}

export interface SingleCommunity {
  id: string;
  name: string;
  description?: string;
  moderator_id?: string;
  status: 'OPEN' | 'PRIVATE' | 'GLOBAL' | 'CLOSED' | 'DELETED';
  tags?: string[];
  max_users?: number;
  language?: string;
  created_at?: string;
  updated_at?: string;
  moderator?: {
    id: string;
    name: string;
    email?: string;
  };
  moderator_ids?: string[];
  moderators?: IModerator[];
  user_role?: string;
  is_yacht_club_community?: boolean;
  translations?: Record<string, ICommunityTranslation> | null;
}

export interface CommunityListQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: CommunityStatus;
  is_admin_panel?: boolean;
}

export interface UpdateStatusPayload {
  communityId: string;
  status: CommunityStatus;
}

export interface CommunityRequest {
  community_id: string;
  community_name: string;
  user_id: string;
  email: string;
  user_name: string | null;
  reason: string;
  status: string;
  created_at: string;
}

export interface ICommunityRequestData {
  user: {
    id: string;
    name: string;
    email: string;
  };
  community_id: string;
  community_name: string;
  user_id: string;
  email: string;
  user_name: string;
  reason: string;
  status: string;
  created_at: string;
}

export interface PaginatedRequestResponse {
  requests: CommunityRequest[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface CommunityListResponse {
  total_items: number;
  current_page: number;
  total_pages: number;
  page_limit: number;
  joined: ICommunityData[];
  other: ICommunityData[];
}

// Event Management Types
export enum EventStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
}

export interface IEventTranslation {
  title: string;
  description: string;
  location_text?: string;
}

export interface IEventData {
  id: string;
  title: string;
  description: string;
  location_text?: string;
  latitude?: number; // Optional latitude coordinate
  longitude?: number; // Optional longitude coordinate
  start_at: string; // ISO date string (UTC)
  end_at: string; // ISO date string (UTC)
  image?: string; // Image URL
  banner?: string; // Banner URL (deprecated, use banner_images)
  banner_images?: string[]; // Array of banner image URLs
  timezone?: string | null;
  tags?: string[];
  image_captions?: RawImageCaption[];
  media_captions?: ImageCaptionDTO[];
  total_interested?: number;
  status: string; // Changed from EventStatus to string to handle API values
  community_id: string;
  created_by?: string;
  created_at?: string;
  updated_at?: string;
  language?: string;
  translations?: Record<string, IEventTranslation>;
}

export interface IEventFormData extends Partial<IEventData> {
  image_file?: File;
  banner_file?: File;
}

export interface IEventListResponse {
  events: IEventData[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface IEventQueryParams {
  page?: number;
  limit?: number;
  community_id?: string;
  status?: EventStatus;
  search?: string;
}
